module.exports = __webpack_public_path__ + "static/media/1008139.99a6c795.png";